<div class="voyage-container" *ngFor="let container of containers">
  <div class="voyage-container__header">
    <div class="info">
      <div
        class="name"
        [ngClass]="{
          'full-container-bg': voyageType === VOYAGE_TYPES.FULL_CONTAINER,
          'coloading-bg': voyageType === VOYAGE_TYPES.COLOADING
        }"
      >
        <img src="assets/icons/icon-container.svg" />
        <span>{{ container.containerType.name }}</span>
      </div>
      <div class="total-costs">
        <span class="total-costs__title">{{ "LABELS.COSTS" | translate }}</span>
        <span class="total-costs__value">{{ getTotalCostContainer(container) | currency : "USD" : "symbol" : "1.2-2" }}</span>
      </div>
      <div class="number">
        <span class="number__title">#{{ "LABELS.CONTAINER_NUMBER" | translate }}</span>
        <span class="number__value" (click)="changeEditContainerNumberModalState(container)">
          {{ container?.containerNumber ? container?.containerNumber : ("LABELS.ADD_NUM" | translate) }}
        </span>
      </div>

      <lcl-results-files [docs]="getContainerDocs(container.id)" [availableDocTypes]="availableDocTypes"></lcl-results-files>
    </div>
    <div class="actions">
      <span class="file-upload-icon" (click)="openFilesSidebar(container.id)"><i class="fa fa-paperclip"></i></span>
      <div class="secondary">
        <div class="actions d-print-none">
          <dropdown-action [id]="'actions'" className="d-print-none">
            <button dropdown-item type="button" class="dropdown-item" (click)="removeContainer(container.id)">
              {{ "BUTTON.DELETE" | translate }}
            </button>
          </dropdown-action>
        </div>
      </div>
    </div>
  </div>

  <div class="voyage-container__table" *ngIf="!!container.shipments">
    <voyage-shipments-table
      [shipments]="container.shipments"
      [isShowCheckbox]="false"
      [isColoading]="voyageType === VOYAGE_TYPES.COLOADING"
      (moveShipmentSource)="moveShipment($event)"
    ></voyage-shipments-table>
  </div>
</div>

<ng-container [ngTemplateOutlet]="editContainerNumber" [ngTemplateOutletContext]="{ header: 'LABELS.EDIT_CONTAINER' }"></ng-container>

<ng-template #editContainerNumber let-header="header">
  <custom-modal [(open)]="isEditContainerNumberModalOpen" [header]="header | translate">
    <label for="container-number">
      {{ "LABELS.CONTAINER_NUMBER" | translate }}
    </label>
    <input class="form-control" id="container-number" [(ngModel)]="containerNumberValue" />
    <button footer-action type="button" class="btn btn-primary" (click)="updateContainer()">{{ "BUTTON.SAVE" | translate }}</button>
  </custom-modal>
</ng-template>
